import { ACTION_CUSTOM } from '../constants';

import { ICustomIntegration, generateSlugForIntegration } from './customIntegration.interface';
import { IConnectIntegrationConfig } from './integrationConfig.interface';
import { IWorkflowBase } from './workflow.interface';

export type IConnectIntegration = {
  id: string;
  dateCreated: Date;
  dateUpdated: Date;
  projectId: string;
  configs: IConnectIntegrationConfig[];
  workflows: IWorkflowBase[];
  type: string;
  isActive: boolean;
  customIntegrationId?: string;
  customIntegration?: ICustomIntegration;
};

export interface IConnectIntegrationWithCredentialInfo extends IConnectIntegration {
  hasCredential: boolean;
  connectedUserLimitOnDevCred: number;
  connectedUserLimitReached: boolean;
}

export interface IIntegrationMetadata {
  type: string;
  name: string;
  icon: string;
  brandColor: string;
}

export function getIntegrationTypeName(integration: IConnectIntegration): string | undefined {
  if (integration.type === ACTION_CUSTOM) {
    if (integration.customIntegration) {
      return generateSlugForIntegration(integration.customIntegration);
    }
    throw new Error(
      `Custom integration details are missing from this integration: ${integration.id}`,
    );
  }
  return integration.type;
}

export function isCustomIntegrationTypeName(type: string): boolean {
  return type.startsWith('custom.');
}

export interface IConnectIntegrationWithCredentialInfo extends IConnectIntegration {
  hasCredential: boolean;
  connectedUserLimitOnDevCred: number;
  connectedUserLimitReached: boolean;
}
